module.exports = __webpack_public_path__ + "images/marketing/peeps/join_us.jpg";